import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Check, Loader2 } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import Layout from '../components/Layout';

export default function SubscriptionSuccess() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');

  React.useEffect(() => {
    // Redirect to subscription page which will handle polling
    if (sessionId) {
      navigate(`/subscription?session_id=${sessionId}`, { replace: true });
    }
  }, [sessionId, navigate]);

  return (
    <Layout>
      <div className="container max-w-md py-16">
        <Card className="text-center">
          <CardHeader>
            <div className="mx-auto w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-4">
              <Check className="h-8 w-8 text-green-600" />
            </div>
            <CardTitle className="text-2xl">Zahlung wird verarbeitet...</CardTitle>
          </CardHeader>
          <CardContent>
            <Loader2 className="h-6 w-6 animate-spin mx-auto mb-4" />
            <p className="text-muted-foreground">
              Bitte warten Sie, während wir Ihre Zahlung überprüfen.
            </p>
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
}
